import React, { memo, useState } from 'react';

interface TextCollectionPerResponseTabsWrapperProps {
  className?: string;
  children: (props: {
    tab: TextCollectionPerResponseTab;
    setTab: (tab: TextCollectionPerResponseTab) => void;
  }) => React.ReactNode;
}

export enum TextCollectionPerResponseTab {
  HideDiff = 'Hide Diff',
  ShowDiff = 'Show Diff',
}

const TextCollectionPerResponseTabsWrapper: React.FC<TextCollectionPerResponseTabsWrapperProps> =
  memo(props => {
    const { className, children } = props;
    const [tab, setTab] = useState<TextCollectionPerResponseTab>(
      TextCollectionPerResponseTab.HideDiff,
    );

    return <div className={className}>{children({ tab, setTab })}</div>;
  });

TextCollectionPerResponseTabsWrapper.displayName = 'TextCollectionPerResponseTabsWrapper';

export default TextCollectionPerResponseTabsWrapper;
